// Shared quick-action presets for the agent chat (full page + dock).
// `prompt` is what gets sent to the agent — phrased to kick off the right
// tool flow. `label` is what the client sees on the chip.
//
// QUICK_QUESTIONS surface as "Ask a question" chips; QUICK_REQUESTS surface
// as "Submit a change request" chips. Creative is intentionally omitted —
// creative is 100% designed in-house and clients do not concept, request,
// or review creative through the agent.
export const QUICK_QUESTIONS = [
  {
    label: "How's my performance?",
    prompt:
      "Give me a summary of my campaign performance this month — spend, leads, CPL, and how I'm pacing against budget.",
  },
  {
    label: "How's my budget pacing?",
    prompt:
      "How is my budget pacing this month? Show me total spent, remaining, and which segments are over- or under-pacing.",
  },
  {
    label: 'Compare to last month',
    prompt:
      'Compare my performance this month vs last month — spend, leads, CPL, and booked appointments. Highlight the biggest changes.',
  },
  {
    label: 'Show me my leads',
    prompt:
      'Show me a summary of my leads this month — total volume, quality breakdown, top zips, and how many self-booked.',
  },
];

export const QUICK_REQUESTS = [
  {
    label: 'Change my budget',
    prompt:
      "I'd like to change my budget. Ask me what you need (amount, segment, when to take effect) so you can submit the request.",
  },
  {
    label: 'Update my ZIP coverage',
    prompt:
      "I'd like to add or remove ZIP codes from my coverage. Show me current coverage first, then help me put in the request.",
  },
  {
    label: 'Pause / restart campaigns',
    prompt:
      'I need to pause or restart a campaign. Ask me what you need (which scope, when to take effect, why) and submit the request.',
  },
];
